import { LEAVE_FIELD_ON_ARROWS } from "../listKeyboard";
import { CLOSE_FIELD_BOX, CLOSE_PHONE_FIELD_BOX } from "../payment/closeLayout";

/**
 * Текстово поле в „Депозити" с кутията на полето за сума от „Закрий"
 * (`payment/GivenAmountField.tsx`): същата височина, заобляне, рамка и
 * акцентна рамка при фокус/попълнено — само шрифтът е за текст, не за число.
 */
export function DepositTextField({
  value,
  onChange,
  onEnter,
  placeholder,
  maxLength,
  hasError,
  isPhone,
  autoFocus,
  disabled = false,
  leaveOnArrows = false,
}: {
  value: string;
  onChange: (value: string) => void;
  onEnter: () => void;
  placeholder: string;
  maxLength: number;
  hasError: boolean;
  isPhone: boolean;
  autoFocus: boolean;
  disabled?: boolean;
  /** ↑ ↓ излизат от полето и местят метода вдясно (`listKeyboard.ts`). */
  leaveOnArrows?: boolean;
}) {
  return (
    <div
      className={`flex items-center border bg-pos-card ${isPhone ? CLOSE_PHONE_FIELD_BOX : CLOSE_FIELD_BOX} transition-[border-color,box-shadow] focus-within:border-pos-accent focus-within:shadow-[0_0_0_3px_color-mix(in_srgb,var(--color-pos-accent)_14%,transparent)] ${
        hasError
          ? "border-pos-danger-brd"
          : value !== ""
            ? "border-pos-accent shadow-[0_0_0_3px_color-mix(in_srgb,var(--color-pos-accent)_14%,transparent)]"
            : "border-pos-line"
      }`}
    >
      <input
        {...(leaveOnArrows ? LEAVE_FIELD_ON_ARROWS : {})}
        value={value}
        autoFocus={autoFocus}
        disabled={disabled}
        maxLength={maxLength}
        placeholder={placeholder}
        autoComplete="off"
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            onEnter();
          }
        }}
        // 16px — като antd полетата под него; под 16 iOS зуумва страницата при фокус.
        className="h-full w-full min-w-0 flex-1 border-0 bg-transparent p-0 text-[16px] font-semibold text-pos-ink outline-none placeholder:font-normal placeholder:text-pos-faint disabled:cursor-not-allowed disabled:text-pos-soft2"
      />
    </div>
  );
}
